<template>
  <div class="card mt-4">
    <div class="table-responsive">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center contact-filters-two">
          <!-- Integration Field -->
          <Search class="mr-3" placeholderText="Search (name)" @search="doSearch" />

          <div class="ml-auto mr-3">
            <v-select
              autocomplete="off"
              class="noflow"
              style="min-width:300px;"
              v-model="selectedCountry"
              @input="handleSearchFilters"
              :options="getAllCountries"
              placeholder="All Countries"
              inputId="employer-select"
              label="name"
              :reduce="country => country.name"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>
          <button
            type="button"
            data-toggle="modal"
            href="#addUserModalUserManagment"
            class="btn btn-success add-employer-btn text-nowrap"
          >
            Add Employer
          </button>
        </div>
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">Name</th>
            <th nowrap scope="col">Location</th>
            <th nowrap scope="col"></th>
            <th nowrap scope="col">Employees</th>
            <th nowrap scope="col">Contacts</th>
            <th nowrap scope="col">Created by</th>
            <th nowrap scope="col">Created</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="employer in employers" :key="employer.their_stack_company_id">
            <td id="title" nowrap>
              <router-link
                :to="{
                  name: 'employer_marketing_id',
                  params: { employer_id: employer.id },
                }"
                >{{ employer.name }}</router-link
              >
            </td>
            <td>
              {{ employer.city ? `${employer.city}, ` : '' }}
              {{ employer.country ? employer.country : '' }}
            </td>
            <td>
              <div class="icons">
                <popper
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ employer.website ? 'Website' : 'N/A' }}
                  </div>
                  <div slot="reference">
                    <a :href="employer.website" rel="nofollow" target="_blank"
                      ><svgHelper
                        :name="employer.website ? 'relocate' : 'relocateFalse'"
                      ></svgHelper
                    ></a>
                  </div>
                </popper>

                <popper
                  v-if="employer.recruiting_agency"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ employer.website ? employer.website : 'N/A' }}
                  </div>
                  <div slot="reference">
                    <svgHelper style="fill: #111" name="agency"></svgHelper>
                  </div>
                </popper>
              </div>
            </td>
            <td>{{ formatNumber(employer.employees) }}</td>
            <td>
              {{ employer.mm_employer_approved_contacts_count }} /
              {{ employer.mm_contacts_count }} /
              {{ employer.hiring_team_count }}
            </td>

            <td>{{ employer.creator ? employer.creator : '' }}</td>
            <td>
              {{
                employer.created_at
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorList v-show="employers.length === 0" class="no-data-message" name="noReviewJobs" />
    </div>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">
              Add Employer
            </h5>
            <button
              @click="clearEmployerFields"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUserCheck"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 20px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input id="name" type="text" class="form-control" v-model="addEmployer.name" />
                  <label for="name">Name</label>
                </div>

                <div class="form-group m-label-left marketing-employer">
                  <v-select
                    id="country"
                    class="country-select"
                    v-model="addEmployer.country"
                    @input="
                      fetchCitiesByCountryId($event);
                      addEmployer.city = '';
                    "
                    label="name"
                    :options="getAllCountries"
                    :reduce="country => country"
                    :clearable="false"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching && search.length >= 3">
                        No results found for <em>{{ search }}</em
                        >.
                      </template>
                      <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                    </template>
                  </v-select>
                  <label for="city">Country</label>
                </div>

                <div class="form-group m-label-left marketing-employer">
                  <v-select
                    :disabled="addEmployer.country === ''"
                    class="city-select"
                    v-model="addEmployer.city"
                    label="name"
                    :options="getCitiesListByCountry"
                    :reduce="city => city"
                    :clearable="true"
                  >
                    <template v-slot:no-options>
                      <div style="opacity: 0.5">Please select a country first</div>
                    </template>
                  </v-select>
                  <label for="city">City</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="website"
                    type="text"
                    class="form-control"
                    v-model="addEmployer.website"
                  />
                  <label for="website">Website</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              :disabled="isAdding"
              @click="addNewEmployer"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button
              @click="clearEmployerFields"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    Pagination,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Employers Marketing | Jobshark';
  },
  data: () => ({
    isAdding: false,
    searchText: '',
    pageCount: 10,
    currentPage: 1,
    totalPages: 1,
    employers: [],
    selectedCountry: '',
    isLoading: false,
    addEmployer: {
      name: '',
      postalCode: '',
      city: '',
      country: '',
      employees: '',
      website: '',
    },
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
      'retrieveFreelancerDocumentPreviewAdmin',
      'retrieveCitiesListByCountryId',
    ]),
    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;
      this.handleSearchFilters();
    },

    formatNumber(value) {
      if (value === null || value === undefined) return '';
      return Number(value)
        .toLocaleString()
        .replace(',', ' '); // e.g. 147260 → 147,260
    },

    handleSearchFilters() {
      this.isLoading = true;
      if (this.searchText !== '') {
        this.currentPage = 1;
      }
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/list`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: this.pageCount,
            country: this.selectedCountry,
            mm_employers: [],
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.employers = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;
        this.handleSearchFilters();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.handleSearchFilters();
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.handleSearchFilters();
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.handleSearchFilters();
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.handleSearchFilters();
    },

    addNewEmployer() {
      this.isAdding = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/create`,
          {
            name: this.addEmployer.name,
            postal_code: this.addEmployer.postalCode,
            city: this.addEmployer.city.name,
            country: this.addEmployer.country.name,
            employees: 0,
            website: this.addEmployer.website,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.isAdding = false;
          this.$refs.closeUserCheck.click();
          this.clearEmployerFields();
          this.handleSearchFilters();
          this.$toasted.success('New employer created', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isAdding = false;
        });
    },

    clearEmployerFields() {
      this.addEmployer.name = '';
      this.addEmployer.postalCode = '';
      this.addEmployer.city = '';
      this.addEmployer.country = '';
      this.addEmployer.employees = '';
      this.addEmployer.website = '';
    },

    fetchCitiesByCountryId(country) {
      // this.selectedCountry = e;
      this.retrieveCitiesListByCountryId({ id: country.id });
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getUserProfile',
      'getCurrentPage',
      'getTotalPages',
      'getAllCountries',
      'getCitiesListByCountry',
    ]),
  },
  mounted() {
    this.isLoading = true;
    this.handleSearchFilters();

    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icons {
  display: flex;
  align-items: center;
  .svg-icon {
    &:last-child {
      width: 30px;
      margin-left: 30px;
    }
  }
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
